/**
 * @Author: DKing
 * @Desc: axios 所需的常量
 * @Date: 2019-07-11
 */
// axios content-type
export const CONTENT_TYPE  = {
  form:'application/x-www-form-urlencoded',
  json:'application/json;charset=UTF-8',
  multipart:'multipart/form-data'
};

export const HTTP_CODE = {
  suc: '000000',  // 请求成功
  warn: '100000',  // 前端直接显示
  err: '500000',  // 服务器异常，出错页面
  err_auth:'400101',  // 无权访问 ,没有权限
  err_params:'400201',  // 参数非法 弹框提示
  err_risk_request:'400301',  // 风控拦截 - 没有session_token 直接跳转到登录页 清除cookie和local
  err_operate:'400401',  // 风控拦截 - 异常请求 清除cookie和local
  err_status:'201030',  // 用户状态有问题，弹窗
  err_login:'20100',  // sessionId有问题，跳转到登录
  err_res:'100100',//如果状态码为100100直接跳页面
  err_first:'200600',//如果账号首次登陆
}


// WEBPACK FOOTER //
// ./src/service/axios_constants.js